import axios from "axios";
import { getToken } from "../../../auth/authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + "/admin/similar-words",
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ===== GROUPS =====
export const fetchGroups = async (params = {}) => {
  try {
    const cleaned = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== "" && v != null));
    const res = await api.get("/groups", { params: cleaned });
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Failed to fetch" };
  }
};

export const fetchGroupById = async (id) => {
  try { const res = await api.get(`/groups/${id}`); return { status: res.status, data: res.data }; }
  catch (err) { return { status: err.response?.status || 500, message: err.response?.data?.message || "Failed to fetch" }; }
};

export const createGroup = async (data) => {
  try {
    console.log("[SimilarWordsService] createGroup URL:", process.env.REACT_APP_BASE_URL + "/admin/similar-words/groups");
    console.log("[SimilarWordsService] createGroup payload:", data);
    const res = await api.post("/groups", data);
    console.log("[SimilarWordsService] createGroup response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[SimilarWordsService] createGroup error:", err.response?.status, JSON.stringify(err.response?.data, null, 2));
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Create failed", data: err.response?.data };
  }
};

export const updateGroup = async (id, data) => {
  try {
    console.log("[SimilarWordsService] updateGroup URL:", process.env.REACT_APP_BASE_URL + `/admin/similar-words/groups/${id}`);
    console.log("[SimilarWordsService] updateGroup payload:", data);
    const res = await api.put(`/groups/${id}`, data);
    console.log("[SimilarWordsService] updateGroup response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[SimilarWordsService] updateGroup error:", err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Update failed", data: err.response?.data };
  }
};

export const deleteGroup = async (id) => {
  try { const res = await api.delete(`/groups/${id}`); return { status: res.status }; }
  catch (err) { return { status: err.response?.status || 500, message: err.response?.data?.error || err.response?.data?.message || "Delete failed" }; }
};

// ===== WORDS =====
export const fetchWordsByGroup = async (groupId) => {
  try { const res = await api.get(`/groups/${groupId}/words`); return { status: res.status, data: res.data }; }
  catch (err) { return { status: err.response?.status || 500, message: err.response?.data?.message || "Failed to fetch" }; }
};

export const createWord = async (data) => {
  try {
    console.log("[SimilarWordsService] createWord URL:", process.env.REACT_APP_BASE_URL + "/admin/similar-words/words");
    console.log("[SimilarWordsService] createWord payload:", data);
    const res = await api.post("/words", data);
    console.log("[SimilarWordsService] createWord response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[SimilarWordsService] createWord error:", err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Create failed" };
  }
};

export const updateWord = async (id, data) => {
  try {
    console.log("[SimilarWordsService] updateWord URL:", process.env.REACT_APP_BASE_URL + `/admin/similar-words/words/${id}`);
    console.log("[SimilarWordsService] updateWord payload:", data);
    const res = await api.put(`/words/${id}`, data);
    console.log("[SimilarWordsService] updateWord response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[SimilarWordsService] updateWord error:", err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Update failed" };
  }
};

export const deleteWord = async (id) => {
  try { const res = await api.delete(`/words/${id}`); return { status: res.status }; }
  catch (err) { return { status: err.response?.status || 500, message: err.response?.data?.message || "Delete failed" }; }
};

export const searchWords = async (searchTerm) => {
  try { const res = await api.get("/words/search", { params: { searchTerm } }); return { status: res.status, data: res.data }; }
  catch (err) { return { status: err.response?.status || 500, message: err.response?.data?.message || "Search failed" }; }
};

// Search vocabularies (uses base URL without /admin/similar-words prefix)
const vocabApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: { "Content-Type": "application/json" },
});
vocabApi.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
export const searchVocabularies = async (search) => {
  try {
    console.log("[SimilarWordsService] searchVocabularies term:", search);
    const res = await vocabApi.get("/admin/vocabulary", { params: { page: 0, size: 10, search } });
    console.log("[SimilarWordsService] searchVocabularies response:", res.status, "count:", res.data?.content?.length ?? res.data?.length);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[SimilarWordsService] searchVocabularies error:", err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Search failed" };
  }
};
